<div class="default-dialog">
    <div class="dialog-header">
        <h3>{{ data.title }}</h3>
        <div class="header-close">
            <button mat-icon-button color="primary" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <p [innerHTML]="data.question"></p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false">{{ data.no }}</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ data.yes }}</button>
    </mat-dialog-actions>
</div>
